import { NavigationMenu } from '@/components/ui/navigation-menu';
import { CommandPaletteTrigger } from '@/modules/commandPalette/CommandPaletteTrigger';

import { AccountMenu } from './AccountMenu/AccountMenu';
import { Changelog } from './Changelog';
import { HelpMenu } from './HelpMenu';
import { MainList } from './MainList';
import { UpgradeButton } from './UpgradeButton';
import { UserMenu } from './UserMenu';

export const MainNavigation = () => {
  return (
    <NavigationMenu
      viewport={false}
      delayDuration={0}
      className="flex h-(--newheader-height) w-full flex-none justify-between pr-4 pl-3 lg:pr-5 lg:pl-4 xl:pr-6 xl:pl-5 2xl:pr-8 2xl:pl-7"
      style={{ background: 'linear-gradient(90deg, #172554 25%, #3352BA 100%)' }}
    >
      <MainList />
      <div className="flex items-center gap-1">
        <UpgradeButton />
        <CommandPaletteTrigger />
        <AccountMenu />
        <Changelog />
        <HelpMenu />
        <UserMenu />
      </div>
    </NavigationMenu>
  );
};
